import {
    FETCH_PRODUCT_PROPERTIES,
    FETCH_PRODUCT_PROPERTIES_FAILURE,
    FETCH_PRODUCT_PROPERTIES_SUCCESS,

    FETCH_PRODUCT_PROPERTY,
    FETCH_PRODUCT_PROPERTY_FAILURE,
    FETCH_PRODUCT_PROPERTY_SUCCESS,
} from 'store/actions/types';

// Fetch Product Properties
export const fetchProductProperties = (payload) => {
    return {
        type: FETCH_PRODUCT_PROPERTIES,
        payload: payload,
    };
};

export const fetchProductPropertiesFailure = (error) => {
    return {
        type: FETCH_PRODUCT_PROPERTIES_FAILURE,
        error: error,
    };
};

export const fetchProductPropertiesSuccess = (payload, response) => {
    return {
        type: FETCH_PRODUCT_PROPERTIES_SUCCESS,
        payload: payload,
        response: response,
    };
};

// Fetch Product Property
export const fetchProductProperty = (payload) => {
    return {
        type: FETCH_PRODUCT_PROPERTY,
        payload: payload,
    };
};

export const fetchProductPropertyFailure = (error) => {
    return {
        type: FETCH_PRODUCT_PROPERTY_FAILURE,
        error: error,
    };
};

export const fetchProductPropertySuccess = (payload, response) => {
    return {
        type: FETCH_PRODUCT_PROPERTY_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/productProperties/fetchProductProperties.js